/* eslint-disable react/prop-types */
import React from 'react';

import {batch, connect} from 'react-redux';

import {showLoading} from '@/actions/loadingActions';
import {IsShowManualControlAvailablePopUp} from '@/actions/manualControlActions';
import * as modalActions from '@/actions/modalActions';
import {pauseProteinConcentrator, IsFromStopProfile} from '@/actions/setupActions';
import {postStopConcentrator} from '@/api/concentratorApi';
import {hidePauseToRefillModal} from '@/businesses/autoProfileBusiness';
import PopUpWizard from '@/components/popup/PopUpWizard';
import ToggleButtonCustom from '@/components/togglebutton/src/ToggleButtonCustom';
import {RecoveryOfLiquidAction, StopEnum} from '@/constants/autoProfileEnum';
import * as APPDATA from '@/constants/pcConstAppData';
import {RecoveryOfLiquidEvent, StopEvent} from '@/constants/pubSubEnum';
import {newLineHtml} from '@/libs/htmlHelper';
import {eventBusObject} from '@/observers/eventBus';

import {
  DataHelpHome,
  DataHelpConcentrate,
  DataHelpConcentrateMoreThan50,
  DataHelpBufferDiscrete,
  DataHelpBufferContinuous,
  DataHelpAdvancedSetup,
  DataHelpManualControl,
  DataHelpStatusAndGraph,
  DataHelpRecovery,
} from './help/AutoProfileHelp';

/**
 * @enum {Object}
 */
const StopActionMenu = {
  CONTINUE_PROFILE: {
    VALUE: 'CONTINUE_PROFILE',
    LABEL: 'CONTINUE PROFILE',
  },
  MANUAL_CONTROL: {
    VALUE: 'MANUAL_CONTROL',
    LABEL: 'MANUAL CONTROL',
  },
  STOP_AND_RECOVERY_SAMPLE: {
    VALUE: 'STOP_RECOVERY',
    LABEL: 'STOP AND RECOVER SAMPLE',
  },
};

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  modeHelp: store.setupStore.modeHelp,
  StatusManualControl: store.manualControlStore.StatusManualControl,
  AutoRecoveryFlag: store.setupStore?.advSetupSelected?.ConfigAdvSetup?.GeneralAdvSetup?.AutoRecoveryFlag,
}))
class StopAutoProfile extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedStopState: undefined,
      disableManualControl: false,
      isHelpModeEnable: false,
      contentHelp: DataHelpHome,
    };

    this._bus = eventBusObject();
    this.stopProcessSubs = this._bus.subscribe(StopEvent.STOP_PROCESS, (e) => this.stopAction(e));
    this.pauseProcessSubs = this._bus.subscribe(StopEvent.PAUSE_PROCESS, (e) => this.pauseAction(e));
    this.recoveryOptionSubs = this._bus.subscribe(StopEvent.RECOVERY_OPTION, (e) => this.recoveryAction(e));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {modeHelp} = this.props;

    if (modeHelp !== nextProps.modeHelp) {
      let content;
      switch (nextProps.modeHelp) {
        case APPDATA.HOME_HELP:
          content = DataHelpHome;
          break;
        case APPDATA.CONCENTRATE_HELP:
          content = DataHelpConcentrate;
          break;
        case APPDATA.CONCENTRATE50ML_HELP:
          content = DataHelpConcentrateMoreThan50;
          break;
        case APPDATA.BUFFER_DISCRETE_HELP:
          content = DataHelpBufferDiscrete;
          break;
        case APPDATA.BUFFER_CONTINOUS_HELP:
          content = DataHelpBufferContinuous;
          break;
        case APPDATA.ADVANCED_SETUP_HELP:
          content = DataHelpAdvancedSetup;
          break;
        case APPDATA.MANUAL_CONTROL_HELP:
          content = DataHelpManualControl;
          break;
        case APPDATA.STATUS_GRAPH_HELP:
          content = DataHelpStatusAndGraph;
          break;
        case APPDATA.RECOVERY_HELP:
          content = DataHelpRecovery;
          break;
        default:
          content = DataHelpHome;
          break;
      }
      this.setState({
        contentHelp: content,
      });
    }
  }

  componentWillUnmount() {
    this.stopProcessSubs.unsubscribe();
    this.pauseProcessSubs.unsubscribe();
    this.recoveryOptionSubs.unsubscribe();
  }

  stopAction = () => {
    console.log('stopAction');
    this.setState({selectedStopState: StopActionMenu.CONTINUE_PROFILE.VALUE, disableManualControl: false}, () => {
      this.createModalContent();
    });
  };

  createModalContent = () => {
    const {StatusManualControl, AutoRecoveryFlag, dispatch} = this.props;
    const {selectedStopState, disableManualControl} = this.state;
    console.log({
      selectedStopState,
      disableManualControl,
      ss: StatusManualControl.IsLastConcentration,
      AutoRecoveryFlag,
    });

    const popUpButton = [
      {
        id: APPDATA.PROCEED,
        isPrimaryButton: true,
        onClick: this.onClick,
        label: APPDATA.PROCEED,
        disabled: selectedStopState === undefined,
      },
    ];

    const stopActionButtonProps = [
      {
        id: StopActionMenu.CONTINUE_PROFILE.VALUE,
        label: StopActionMenu.CONTINUE_PROFILE.LABEL,
        value: StopActionMenu.CONTINUE_PROFILE.VALUE,
        onClick: this.onClick,
      },
      {
        id: StopActionMenu.MANUAL_CONTROL.VALUE,
        label: StopActionMenu.MANUAL_CONTROL.LABEL,
        value: StopActionMenu.MANUAL_CONTROL.VALUE,
        onClick: this.onClick,
        disabled: disableManualControl || StatusManualControl.IsLastConcentration === 'false',
      },
      {
        id: StopActionMenu.STOP_AND_RECOVERY_SAMPLE.VALUE,
        label: StopActionMenu.STOP_AND_RECOVERY_SAMPLE.LABEL,
        value: StopActionMenu.STOP_AND_RECOVERY_SAMPLE.VALUE,
        onClick: this.onClick,
      },
    ];

    const bodyContent = (
      <div className="row">
        <div className="col-md-12">
          {newLineHtml(APPDATA.MESSAGES.PROFILE.STOP_PROFILE.CONTENT)}
          <ToggleButtonCustom
            buttonProp={stopActionButtonProps}
            // defaultValue={STOP_ACTION_MENU.CONTINUE_PROFILE.VALUE}
            value={selectedStopState}
            onClick={this.onClick}
            block
            vertical
          />
        </div>
      </div>
    );

    dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.MESSAGES.PROFILE.STOP_PROFILE.TITLE,
        popUpText: bodyContent,
        popUpButton,
        popUpHideCloseButton: true,
        popUpClose: this.onClosePopUp,
      }),
    );
  };

  onClosePopUp = async () => {
    const {dispatch} = this.props;

    await postStopConcentrator(StopEnum.CONTINUE);

    batch(() => {
      dispatch(
        pauseProteinConcentrator({
          isPCPaused: false,
        }),
      );
      dispatch(modalActions.hidePopUp());
    });
  };

  onClick = async (e) => {
    const {dispatch} = this.props;
    const {id} = e.currentTarget;

    switch (id) {
      case APPDATA.PROCEED: {
        const {selectedStopState} = this.state;
        switch (selectedStopState) {
          case StopActionMenu.CONTINUE_PROFILE.VALUE: {
            await postStopConcentrator(StopEnum.CONTINUE);

            batch(() => {
              dispatch(
                pauseProteinConcentrator({
                  isPCPaused: false,
                }),
              );
              dispatch(modalActions.hidePopUp());
            });
            break;
          }
          case StopActionMenu.MANUAL_CONTROL.VALUE:
            this.manualControlConfirmationPopup();

            break;
          case StopActionMenu.STOP_AND_RECOVERY_SAMPLE.VALUE: {
            await postStopConcentrator(StopEnum.RECOVERY);

            this._bus.publish(RecoveryOfLiquidEvent.SHOW_POP_UP, {
              recoveryAction: RecoveryOfLiquidAction.RECOVERY_FROM_STOP_POPUP,
            });
            batch(() => {
              dispatch(modalActions.hidePopUp());
              dispatch(IsFromStopProfile(true));
            });
            break;
          }
          default:
            break;
        }
        dispatch(hidePauseToRefillModal());
        break;
      }
      case StopActionMenu.CONTINUE_PROFILE.VALUE:
      case StopActionMenu.MANUAL_CONTROL.VALUE:
      case StopActionMenu.STOP_AND_RECOVERY_SAMPLE.VALUE:
        this.setState(
          {
            selectedStopState: id,
          },
          () => {
            // ConsoleLog("onClick Stop Option", this.state);
            this.createModalContent();
          },
        );
        break;
      default:
        //   ConsoleLog("onClick Stop Option Default", this.state, id, STOP_ACTION_MENU, e.currentTarget);
        break;
    }
  };

  manualControlConfirmationPopup = () => {
    const {dispatch} = this.props;

    const manualControlButton = [
      {
        id: APPDATA.HELP,
        isPrimaryButton: false,
        onClick: this.manualControlPopUpAction,
        label: APPDATA.HELP,
        className: 'tertiaryButton',
      },
      {
        id: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: this.manualControlPopUpAction,
        label: APPDATA.CANCEL,
      },
      {
        id: APPDATA.CONFIRM,
        isPrimaryButton: true,
        onClick: this.manualControlPopUpAction,
        label: APPDATA.CONFIRM,
      },
    ];

    dispatch(
      modalActions.showPopUp({
        popUpTitle: 'Manual Control',
        popUpText: (
          <div className="center">
            <span>{newLineHtml(APPDATA.MESSAGES.MANUAL_CONTROL.POP_UP_BUTTON_SWITCH_MANUAL_CONTROL)}</span>
          </div>
        ),
        popUpButton: manualControlButton,
        popUpHideCloseButton: true,
      }),
    );
  };

  onCloseHelpWizard = () => {
    this.setState({
      isHelpModeEnable: false,
      contentHelp: DataHelpHome,
    });
    this.createModalContent(false);
  };

  manualControlPopUpAction = async (e) => {
    const {dispatch} = this.props;

    switch (e.currentTarget.id) {
      case APPDATA.CONFIRM: {
        await dispatch(IsShowManualControlAvailablePopUp(true));
        await postStopConcentrator(StopEnum.MANUAL_CONTROL);

        batch(() => {
          dispatch(
            pauseProteinConcentrator({
              isPCPaused: false,
            }),
          );
          dispatch(modalActions.hidePopUp());
        });

        break;
      }
      case APPDATA.CANCEL:
        dispatch(modalActions.hidePopUp());
        this.createModalContent(false);
        break;
      case APPDATA.HELP:
        this.setState({
          isHelpModeEnable: true,
        });
        dispatch(modalActions.hidePopUp());
        break;
      default:
        break;
    }
  };

  pauseAction = async (e) => {
    const {disableManualControl} = e;
    const {dispatch} = this.props;

    await postStopConcentrator(StopEnum.PAUSED);

    dispatch(showLoading(false));

    this.setState({selectedStopState: undefined, disableManualControl}, () => {
      this.createModalContent(disableManualControl);
    });
  };

  // #endregion Stop Auto Profile REST API Request handler

  // eslint-disable-next-line class-methods-use-this
  recoveryAction = async (e) => {
    console.log('recoveryAction');
    await postStopConcentrator(StopEnum.RECOVERY);
    // wait backend at recovery state
    // TODO : Create an api to handle stop recovery then recoery option
    setTimeout(() => {
      e.callBackRecoveryRequest.callBack(e.callBackRecoveryRequest.param);
    }, 1200);
  };

  render() {
    const {fontSize} = this.props;
    const {contentHelp, isHelpModeEnable} = this.state;

    return (
      <PopUpWizard
        data={contentHelp}
        fontSize={fontSize}
        popUpWizardVisible={isHelpModeEnable}
        onClose={this.onCloseHelpWizard}
      />
    );
  }
}
export default StopAutoProfile;
